module.exports = __webpack_public_path__ + "02e3287668ca1107e0c3f358480fe019.png";